<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CI7bUD/tc-custom/9781460363836.jpg?1705201552368" alt="This image is the cover for the book Flash Point"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Flash Point
      </h1>
      <p class="bookDescription body article font2">
        <b>Is a picture worth a thousand words</b><br/><br/>New York photographer Kelly Santos hides behind her camera and her talent, where no one can know about her tragic pastor the visions that haunt her.<br/><br/><b><i>when it exposes a deadly truth?</i></b><br/><br/>Now the past is reaching out to her, calling her back to her native New Orleans, to the hidden danger that waits. From the moment Kelly returns she is plagued by visions of murder. But no one believes heruntil a man turns up dead, and Kelly becomes the prime suspect. Seeking the help of homicide detective Jack Callaghan, she sets out to prove her innocence.<br/><br/>But Kelly's quest for answers is leading them both on a treacherous path to the heart of a sinister secretand to a killer who is prepared to finish a grim and deadly task begun many years ago. Soon past, present and future will collide in an explosive, shattering<br/><br/><b><i>FLASH POINT</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Metsy Hingle
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6ba93f78